export default __webpack_public_path__ + "static/media/pit-crew-background.0aa346a1.webp";